module.exports = __webpack_public_path__ + "/images/shop/icon/visa_ms_carte_bancaire.svg";